



























































































































import { computed, defineComponent, getCurrentInstance, onMounted, ref } from "vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import TermsModal from "@/components/Organisms/CheckupDigitalOmint/TermsModal.vue";
import {
  ObterPrograma,
  ObterUrl,
  PROGRAMA_PRESTADOR_ACCESS_ERROR,
  programaPrestadorErrorMessage
} from "@/api/programaPrestador";
import { openCheckupDigitalPartner } from "@/utils/checkupDigitalOmint";

const coverImage = process.env.VUE_APP_BASE_URL + "images/health_programs/avaliacao-saude.png";

function isUnauthorized(error: unknown) {
  const err = error as { code?: number; response?: { status?: number } };
  return err.code === 401 || err.response?.status === 401;
}

export default defineComponent({
  components: {
    FixedButtonRow,
    TermsModal
  },
  setup() {
    const context = getCurrentInstance().proxy;
    const accepted = ref(false);
    const showTerms = ref(false);
    const submitting = ref(false);
    const loaded = ref(false);
    const possuiOptInVigente = ref(false);

    const vinculo = () => context.$store.state.saude.vinculo as string;

    onMounted(async () => {
      try {
        const response = await ObterPrograma({ vinculo: vinculo() });
        possuiOptInVigente.value = !!response?.PossuiOptInVigente;
      } catch (error) {
        possuiOptInVigente.value = false;
        if (!isUnauthorized(error)) {
          context.$toast({
            title: programaPrestadorErrorMessage(error, PROGRAMA_PRESTADOR_ACCESS_ERROR),
            status: "error",
            duration: 10000,
            position: "top"
          });
        }
      } finally {
        loaded.value = true;
        context.$root.$emit("hide-loading");
      }
    });

    const showCheckbox = computed(() => loaded.value && !possuiOptInVigente.value);
    const canStart = computed(() => {
      if (!loaded.value || submitting.value) return false;
      if (showCheckbox.value) return accepted.value;
      return true;
    });

    const startEvaluation = async () => {
      if (!canStart.value || submitting.value) return;

      submitting.value = true;
      try {
        const { Url } = await ObterUrl({ vinculo: vinculo() });
        openCheckupDigitalPartner(Url);
      } catch (error) {
        if (isUnauthorized(error)) return;
        context.$toast({
          title: programaPrestadorErrorMessage(error, PROGRAMA_PRESTADOR_ACCESS_ERROR),
          status: "error",
          duration: 10000,
          position: "top"
        });
      } finally {
        submitting.value = false;
      }
    };

    return {
      coverImage,
      accepted,
      showTerms,
      submitting,
      showCheckbox,
      canStart,
      startEvaluation
    };
  }
});
